/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EffectiveCoefficientRange } from '../models/EffectiveCoefficientRange';
import type { FinancialCoefficientRange } from '../models/FinancialCoefficientRange';
import type { PatchedFinancialCoefficientRange } from '../models/PatchedFinancialCoefficientRange';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class FinancialCoefficientRangeService {

  /**
   * List company-wide coefficient ranges
   * Correction coefficient range allowed on each sales channel (management view — returns every row). Per-broker ranges are configured on the broker's products and take precedence over these values.
   * @param ordering Ordering fields: scope
   * @returns FinancialCoefficientRange 
   * @throws ApiError
   */
  public static financialCoefficientRangeList(
ordering?: string,
): CancelablePromise<Array<FinancialCoefficientRange>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/financial/coefficient-range/',
      query: {
        'ordering': ordering,
      },
    });
  }

  /**
   * Retrieve a coefficient range
   * Management view — reference table, seeded by defaults(), no create/delete via API.
   * @param scope 
   * @returns FinancialCoefficientRange 
   * @throws ApiError
   */
  public static financialCoefficientRangeRetrieve(
scope: 'direct',
): CancelablePromise<FinancialCoefficientRange> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/financial/coefficient-range/{scope}/',
      path: {
        'scope': scope,
      },
    });
  }

  /**
   * Update a coefficient range
   * Editable by an admin only. Values must stay within the technical frame 0.10-10.00.
   * @param scope 
   * @param requestBody 
   * @returns FinancialCoefficientRange 
   * @throws ApiError
   */
  public static financialCoefficientRangePartialUpdate(
scope: 'direct',
requestBody?: PatchedFinancialCoefficientRange,
): CancelablePromise<FinancialCoefficientRange> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/financial/coefficient-range/{scope}/',
      path: {
        'scope': scope,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Coefficient range of the caller
   * The correction coefficients **this seller** may use, resolved from who is calling: a broker employee gets the range configured for their broker, an Intact employee gets the company-wide one.
 *
 * Ask for this before quoting. The bounds are the same ones the price endpoint validates against, so a coefficient accepted here is accepted there — while reading them off a price response costs a draft order. The tariff values come along so the screen can show the premium (`standard_prime x coefficient`) as the input moves.
 *
 * An order already priced is **not** measured against this range but against the one pinned into it: narrowing a broker's range applies to new orders only. Clamp the input on an existing order to `data.coefficient_min` / `coefficient_max` of that order.
   * @returns EffectiveCoefficientRange 
   * @throws ApiError
   */
  public static financialCoefficientRangeEffectiveRetrieve(): CancelablePromise<EffectiveCoefficientRange> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/financial/coefficient-range/effective/',
    });
  }

}
